module.exports = __webpack_public_path__ + "static/media/presentation-mosprom.6ede0fa3.pdf";